module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/6163109aa548a72df88bb57099186294.png";